import React from 'react'
import utilities from '../../../utilities'

const UserFullName = ({
    user,
    style = {},
    className = ''
}) => {
    const name = utilities.getUserFullName(user, { grade: true, familyFirst: true })
    return (
        <span style={style} className={className}>
            {name}
        </span>
    )
}

export default UserFullName